module.exports = __webpack_public_path__ + "media/tr_tr_s4_Nehir.0d7eb3f1.oga";